import * as React from "react";
import { FC } from "react";
import { CloseButton } from "../Elements/CloseButton";
import { PopupBody, PopupFooter, PopupHeader, Popup } from "./Popup";
import { useNomaContext } from "../Contexts/MapContext";
import { DocumentList } from "./DocsSection";
import { PopupButton } from "../Elements/PopupButton";
import { config } from "../Map/config";

export const Downloads: FC = () => {
    const { downloadsPopupDocs, setDownloadsPopupDocs } = useNomaContext();

    const x = document.body.clientWidth / 2 - 225;

    const onClick = () =>
        (window.location.href =
            config.dataView.docsApi + "/files/related/PUBSDE.LandPlotCatalog/" + downloadsPopupDocs.objectId);
    return (
        <Popup id={"downloads-popup"} isMobile={false} hasBackdrop={false} defaultPosition={{ x, y: 0 }}>
            <PopupHeader isMobile={false}>
                <div>Lejuplādējamie pielikumi</div>
                <CloseButton onClose={() => setDownloadsPopupDocs(null)}></CloseButton>
            </PopupHeader>
            <PopupBody isMobile={false}>
                <DocumentList docs={downloadsPopupDocs.docs}></DocumentList>
            </PopupBody>
            <PopupFooter isMobile={false}>
                <PopupButton
                    title={"Lejupielādēt visus failus"}
                    icon={"icon-zemesnoma-forward"}
                    onClick={onClick}
                ></PopupButton>
            </PopupFooter>
        </Popup>
    );
};
